import React, { Component } from 'react';
import { Checkbox, InfoTooltip } from 'framework-ui-components';

function StatoDaImportare(stato) {
  switch (stato) {
    case 0:
      return 'Importabile';
    case 1:
      return 'Sovrascrivi esistente';
    case 2:
      return 'Non importabile';
    default:
      return '';
  }
}

class RigaImportazione extends Component {
  render() {
    const {
      item,
    } = this.props;

    return (
      <tr>
        <td><Checkbox
          checked={item.DaImportare}
          onChange={() => this.props.additionalRowData.impostaDaImportare(item.CodiceFiscaleDichiarante)}
          disabled={item.StatoDichiarazioneDaImportare == 2}
        />
        </td>
        <td>{item.CodiceUfficio}</td>
        <td>{item.DescrizioneDichiarante}</td>
        <td>{item.CodiceFiscaleDichiarante}</td>
        <td>{item.Tipo}</td>
        <td>
          {StatoDaImportare(item.StatoDichiarazioneDaImportare)}
          {item.StatoDichiarazioneDaImportare == 2 && (
            <InfoTooltip placement="top">
              {item.CodiceFiscaleDoppio
                ? 'La dichiarazione non è importabile in quanto il codice fiscale del contribuente è presente più volte tra le dichiarazioni da importare'
                : 'La dichiarazione non è importabile perché esiste già una dichiarazione con status diverso da “Anno precedente”, “Errata”, ”In lavorazione” o “Annullata”.'}
            </InfoTooltip>
          )}
        </td>
        <td>{item.DescrizioneConiuge}</td>
        <td>{item.CodiceFiscaleConiuge}</td>
        <td>{item.DescrizioneSostituto}</td>
      </tr>
    );
  }
}

export default RigaImportazione;
